import { marked } from 'marked'
import DOMPurify from 'dompurify'

marked.use({
  renderer: {
    heading(text, level) {
      return `<h${level}>${text}</h${level}>`
    },
    image: () => '',
    link: (href, title, text) => {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`
    },
    code: (code) => {
      return `<pre class="rounded-md border border-dark-border-solid bg-dark-bg"><code>${code}</code></pre>`
    },
    list: (text, ordered) => {
      if (!ordered) return `<ul class="list-disc">${text}</ul>`

      return `<ol class="list-decimal">${text}</ol>`
    },
    listitem: (text) => {
      if (!text) return ''

      return `<li class="">${text}</li>`
    },
  },
  pedantic: false,
  gfm: true,
  breaks: false,
})

export const md = (text: string) => {
  return DOMPurify.sanitize(marked(text) as string)
}
